import { TypedUseQueryHookResult } from '@reduxjs/toolkit/dist/query/react';

import { useGetProjectsQuery } from '@verantos-dev/data-access-projects';
import { ListResponse } from '@verantos-dev/types-common';
import type { ProjectDetail } from '@verantos-dev/types-projects';

export const useProjectsDataGridFetch: TypedUseQueryHookResult<
  ListResponse<ProjectDetail>,
  string | null,
  any,
  any
> = (searchParams?: string) => {
  return useGetProjectsQuery(searchParams || '', {});
};
